module.exports = __webpack_public_path__ + "us.svg?9ea6fc12d02469692021c165c8f72390";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/us.svg
// module id = 966
// module chunks = 27